export const headerTitleElementId = 'browse-bids-header-title';
export const bidListTitleElementId = 'bid-list-title';
export const browseBidBaseURLStorageKey = 'seo-base-url';
export const browseBidFullTitleStorageKey = 'seo-full-title';
export const commodityCodeElementId = 'commodity-code-tree-title';
export const geoCodeElementId = 'state-msa-tree-title';
export const staticHeaderClassName = 'staticHeader';
